import { useSelector } from 'react-redux'

import { PATHS } from '~/pages/router/paths'
import Permission from '~/permissions/model/permissions.model'
import { selectPermissions } from '~/permissions/store/permissions.selectors'

export default function usePermissions() {
  const permissions = useSelector(selectPermissions)

  const accessPermissions = {
    [Permission.SELL_RECRUITMENT]: {
      id: Permission.SELL_RECRUITMENT,
      access: [PATHS.CUSTOMER],
    },
    [Permission.SELL_PORTFOLIO]: {
      id: Permission.SELL_PORTFOLIO,
      access: [PATHS.CUSTOMER],
    },
    [Permission.CANCEL]: {
      id: Permission.CANCEL,
      access: [PATHS.CUSTOMER],
    },
    [Permission.UNSUBSCRIBE]: {
      id: Permission.UNSUBSCRIBE,
      access: [PATHS.CUSTOMER],
    },
    [Permission.CONFIGURE_OFFER]: {
      id: Permission.CONFIGURE_OFFER,
      access: [PATHS.CUSTOMER, PATHS.OFFERS_CONFIGURATOR],
    },
    [Permission.VIEW]: {
      id: Permission.VIEW,
      access: [PATHS.CUSTOMER, PATHS.PRODUCT, PATHS.RECHARGES],
    },
    [Permission.EDIT]: { id: Permission.EDIT, access: [PATHS.CUSTOMER] },
    [Permission.ADMINISTRATE_DISCOUNTS]: {
      id: Permission.ADMINISTRATE_DISCOUNTS,
      access: [PATHS.CUSTOMER],
    },
    [Permission.ADMINISTRATE_BONUSES]: {
      id: Permission.ADMINISTRATE_BONUSES,
      access: [PATHS.CUSTOMER],
    },
    [Permission.VIEW_ENERGY_CONTRACTS]: {
      id: Permission.VIEW_ENERGY_CONTRACTS,
      access: [PATHS.CUSTOMER, PATHS.ENERGY],
    },
    [Permission.ADMINISTRATE_ENERGY_CONTRACTS]: {
      id: Permission.ADMINISTRATE_ENERGY_CONTRACTS,
      access: [PATHS.CUSTOMER],
    },
  }

  const allAccess = permissions?.reduce((acc, permission) => {
    return acc.concat(accessPermissions[permission]?.access)
  }, [] as PATHS[])

  const routePermissions = (route: PATHS) => allAccess?.includes(route)

  return {
    hasPermissionsToAccessRoute: (route: PATHS) => routePermissions(route),
  }
}
